import MetaModel from "../../../../Global/Models/Pagination/MetaModel";
import BracketGamePredictionModel from "../Prediction/StandingGamePredictionModel";

export default class StandingGameRankingsModel {
  public meta: MetaModel = new MetaModel();
  public data: BracketGamePredictionModel[] = [];
}
